import { Pipe, PipeTransform } from '@angular/core';
import { DateService } from "libraries/date/date.service";

@Pipe({
    name: 'dateIgnoreOffset'
})
export class DateIgnoreOffsetPipe implements PipeTransform {

    constructor(private readonly dateService: DateService) {
    }

    public transform(dateTimeStr: string, formatStr?: string): string {
        return this.dateService.formatDateIgnoreOffset(dateTimeStr, formatStr);
    }

}
